import BoasVindasCustosView from "../../components/gestaoOrcamentaria/BoasVindasCustosView";

export default function BoasVindasCustos() {
  return <BoasVindasCustosView />;
}
